import { combineReducers } from 'redux';

import ProductionVisState from '../modules/ProductionVis/VisState';
import DevicesVisState from '../modules/DevicesVis/VisState';
import PricesVisState from '../modules/PricesVis/VisState';
import ImportExportVisState from '../modules/ImportExportVis/VisState';

export default combineReducers({
  ProductionVisState,
  DevicesVisState,
  PricesVisState,
  ImportExportVisState
});



// WEBPACK FOOTER //
// ./src/redux/reducer.js